/* Each section owns its interactions; native controls remain usable while plugins load. */
(() => {
  if (customElements.get('dio-section-interactions')) return;
  const anchors = new Set();
  function anchorClick(event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('a[href*="#"]');
    if (!link || link.hasAttribute('download') || link.target && link.target !== '_self' || !window.jQuery) return;
    if (!link.hash || link.hash === '#0' || link.pathname !== location.pathname || link.hostname !== location.hostname) return;
    let id; try { id = decodeURIComponent(link.hash.slice(1)); } catch (_) { return; }
    const target = document.getElementById(id) || document.getElementsByName(id)[0];
    if (!target) return;
    event.preventDefault();
    const $ = window.jQuery;
    const focus = () => {
      target.focus({preventScroll:true});
      if (document.activeElement !== target) { target.setAttribute('tabindex', '-1'); target.focus({preventScroll:true}); }
    };
    const duration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 1000;
    $('html, body').stop(true).animate({scrollTop:$(target).offset().top}, duration).promise().done(focus);
  }
  function anchorOwner(owner) {
    if (!anchors.size) document.addEventListener('click', anchorClick);
    anchors.add(owner);
    return () => { anchors.delete(owner); if (!anchors.size) document.removeEventListener('click', anchorClick); };
  }
  customElements.define('dio-section-interactions', class extends HTMLElement {
    async connectedCallback() {
      const generation = this.generation = (this.generation || 0) + 1;
      const cleanups = [];
      this.cleanup = () => { cleanups.splice(0).forEach(cleanup => cleanup()); };
      const current = () => this.isConnected && this.generation === generation;
      try {
        await window.DioAssets.domReady;
        if (!current()) return;
        const scope = this.closest('[id^="shopify-section-"]') || this.parentElement;
        const kind = this.dataset.kind;
        if (kind === 'anchors' || kind === 'support-faq') cleanups.push(anchorOwner(this));
        const find = id => Array.from(scope.querySelectorAll('[id]')).find(node => node.id === id);
        const activate = (button, fn) => {
          if (!button.matches('button,a,input')) {
            button.setAttribute('role', 'button'); button.tabIndex = 0;
          }
          const key = event => {
            if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); fn(event); }
          };
          button.addEventListener('click', fn);
          if (!button.matches('button,a,input')) button.addEventListener('keydown', key);
          cleanups.push(() => { button.removeEventListener('click', fn); button.removeEventListener('keydown', key); });
        };
        const toggle = (button, panel, duration = 300) => {
          if (!panel) return;
          const open = getComputedStyle(panel).display === 'none';
          button.setAttribute('aria-expanded', String(open));
          if (window.jQuery) window.jQuery(panel).stop(true, true)[open ? 'slideDown' : 'slideUp'](duration);
          else panel.style.display = open ? 'block' : 'none';
          if (open) window.DioPhaseTwo?.refreshInstructionCarousels(scope);
        };
        if (kind === 'support-faq') {
          scope.querySelectorAll('.tab-label').forEach(button => {
            const panel = button.nextElementSibling;
            button.setAttribute('aria-expanded', 'false');
            activate(button, () => toggle(button, panel));
            cleanups.push(() => { if (window.jQuery && panel) window.jQuery(panel).stop(true, true); });
          });
        }
        if (kind === 'legacy-tabs') {
          const tabs = Array.from(scope.querySelectorAll('[data-dio-legacy-tab]'));
          const select = button => {
            tabs.forEach(other => {
              const selected = other === button;
              other.classList.toggle('active', selected);
              other.setAttribute('aria-expanded', String(selected));
              const panel = find(other.dataset.dioLegacyTab);
              if (panel) panel.style.display = selected ? 'block' : 'none';
            });
            window.DioPhaseTwo?.refreshInstructionCarousels(scope);
          };
          tabs.forEach(button => activate(button, () => select(button)));
          if (tabs.length) select(tabs.find(button => button.classList.contains('active')) || tabs[0]);
          scope.querySelectorAll('[data-dio-legacy-accordion]').forEach(button => {
            button.setAttribute('aria-expanded', 'false');
            activate(button, () => toggle(button, find(button.dataset.dioLegacyAccordion), 0));
          });
        }
        if (kind === 'product-panels' || kind === 'legacy-tabs') {
          const roots = Array.from(scope.querySelectorAll('[data-dio-instruction-carousel]:not([data-dio-carousel-managed])'));
          if (!roots.length) return;
          await Promise.all([
            window.DioAssets.dependency('phase-two'),
            window.DioAssets.load('https://cdnjs.cloudflare.com/ajax/libs/OwlCarousel2/2.3.4/owl.carousel.min.js', {dependencies:['jquery'], library:'owlCarousel'})
          ]);
          if (!current()) return;
          this.positions = this.positions || new WeakMap();
          window.DioPhaseTwo.refreshInstructionCarousels(scope);
          roots.forEach(root => {
            const $root = window.jQuery(root);
            if (this.positions.has(root) && $root.data('owl.carousel')) $root.trigger('to.owl.carousel', [this.positions.get(root), 0]);
          });
          cleanups.push(() => roots.forEach(root => {
            const $root = window.jQuery(root), carousel = $root.data('owl.carousel');
            root.dioDotsCleanup?.();
            if (carousel) { this.positions.set(root, carousel.relative(carousel.current())); $root.owlCarousel('destroy'); }
          }));
        }
      } catch (error) { if (current()) console.error(error); }
    }
    disconnectedCallback() {
      this.generation = (this.generation || 0) + 1;
      this.cleanup?.(); this.cleanup = undefined;
    }
  });
})();
